export enum ERestoreEntityType {
  TEACHER = 1,
  STUDENT = 2,
  CLASS = 3,
  LESSON = 4,
}

export enum ELessonStageType {
  EXPLORATION = 1,
  KICK_OFF = 2,
  MASTERY = 3,
  CREATIVITY = 4,
}

export enum EBlockUnblock {
  SCHOOL = 1,
  TEACHER = 2,
  STUDENT = 4,
  CLASS = 7,
  LESSON = 8,
}

export enum EUserRole {
  PARENT = 'parent',
  TEACHER = 'teacher',
  SCHOOL = 'school',
}

export enum ECurrency {
  KWD = 'KWD',
  USD = 'USD',
}

export enum ELessonStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  IN_ACTIVE = 'in_active',
}

export enum ECommonStatus {
  ACTIVE = 'active',
  IN_ACTIVE = 'in_active',
}

export enum EExportType {
  CSV = 1,
  PDF = 2,
}

export enum EWebNotificationCategory {
  SYSTEM = 1,
  LICENSE = 2,
  CHILD = 3,
  LESSON = 4,
  REPORT = 5,
  GENERAL = 6,
  FAQ = 7,
  POLICY = 8,
  NOTIFICATION = 9,
  GAME = 10,
  CLASS = 11,
  STUDENT = 12,
  TEACHER = 13,
  SCHOOL = 14,
  PARENT = 15,
}

export enum EWebNotificationRecipientRole {
  ADMIN = 1,
  PARENT = 2,
  SCHOOL = 3,
  TEACHER = 4,
}

export enum EWebNotificationType {
  // Lessons
  LESSON_CREATED = 1,
  LESSON_DELETED = 2,
  LESSON_BLOCKED = 3,
  LESSON_UNBLOCKED = 4,

  // Class
  CLASS_CREATED = 5,
  CLASS_DELETED = 6,
  CLASS_BLOCKED = 7,
  CLASS_UNBLOCKED = 8,

  // Assignment
  LESSON_ASSIGNED = 9,
  CLASS_ASSIGNED = 10,

  // User/Student/Teacher
  TEACHER_CREATED = 11,
  TEACHER_UPDATED = 12,
  TEACHER_DELETED = 13,
  STUDENT_CREATED = 14,
  STUDENT_UPDATED = 15,
  STUDENT_DELETED = 16,
  TEACHER_BLOCKED = 17,
  TEACHER_UNBLOCKED = 18,
  STUDENT_BLOCKED = 19,
  STUDENT_UNBLOCKED = 20,
  SCHOOL_BLOCKED = 21,
  SCHOOL_UNBLOCKED = 22,
  ADMIN_BLOCKED = 23,
  ADMIN_UNBLOCKED = 24,
  PARENT_DELETED = 25,

  // Content/Game
  GAME_STATUS_UPDATED = 26,
  CHILD_COMPLETED_GAME = 27,

  // Reports
  REPORT_CREATED = 28,
  REPORT_STATUS_UPDATED = 29,

  // Auth/Device
  NEW_DEVICE_LOGIN = 30,

  // System
  FAQ_CREATED = 31,
  FAQ_UPDATED = 32,
  FAQ_DELETED = 33,
  POLICY_CREATED = 34,
  POLICY_UPDATED = 35,
  POLICY_DELETED = 36,

  // General/Others
  DATA_RESTORED = 37,
  SCHOOL_CREATED = 38,
  SCHOOL_UPDATED = 39,
  SCHOOL_DELETED = 40,
  PARENT_REGISTERED = 41,
  PARENT_BLOCKED = 42,
  PARENT_UNBLOCKED = 43,
  ADMIN_DELETED = 44,
}

export enum EContentType {
  LETTERS = 1,
  WORDS = 2,
  SENTENCES = 3,
}

export enum EQuarter {
  Q1 = 1,
  Q2 = 2,
  Q3 = 3,
  Q4 = 4,
}

export enum ESubscriptionStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
  EXPIRING_SOON = 'expiring_soon',
}
